module.exports = __webpack_public_path__ + "img/billCompleted.c7a00c63.svg";